import type { Member, YearlyGrade } from '../types';
import { defaultEvalYear } from './evalYear';

export type ResolvedGrades = {
  finalPerf: string;
  finalBehavior: string;
  note: string;
};

/** 선택 연도 기준 멤버 등급 해석 (yearlyGrades → 레거시 flat) */
export function gradesForYear(
  member: Member | null | undefined,
  evalYear: number,
  legacyYear: number = defaultEvalYear()
): ResolvedGrades {
  const yg = member?.yearlyGrades?.[String(evalYear)] as YearlyGrade | undefined;
  if (yg) {
    return {
      finalPerf: yg.finalPerf || member?.perfGrade || 'GD',
      finalBehavior: yg.finalBehavior || member?.behaviorGrade || 'GD',
      note: yg.note || '',
    };
  }
  if (evalYear === legacyYear || member?.gradeYear == null || member?.gradeYear === evalYear) {
    return {
      finalPerf: member?.finalPerf || member?.perfGrade || 'GD',
      finalBehavior: member?.finalBehavior || member?.behaviorGrade || 'GD',
      note: member?.note || '',
    };
  }
  return {
    finalPerf: member?.perfGrade || 'GD',
    finalBehavior: member?.behaviorGrade || 'GD',
    note: '',
  };
}
